import React from 'react';
import PropTypes from 'prop-types';
import { Link, Stack, Typography } from '@metarouter-private/mr-mui';
import { useDrawerContext } from 'app/shared/contexts/drawer';
import DrawerHeader from 'app/shared/components/drawer/DrawerHeader';

export default function PipelineTransformationsDrawerHeader({ title, documentationUrl }) {
  const {
    drawer: { onClose },
  } = useDrawerContext();
  return (
    <DrawerHeader onClose={onClose}>
      <Stack mb={2}>
        <Typography variant="subtitle1">{title}</Typography>
        <Typography variant="body2" color="secondary">
          This feature is only configurable through the CLI.
          {documentationUrl && (
            <>
              {' '}
              <Link
                color="inherit"
                variant="body2"
                href={documentationUrl}
                underline="always"
                target="_blank"
                rel="noopener"
              >
                Documentation
              </Link>
            </>
          )}
        </Typography>
      </Stack>
    </DrawerHeader>
  );
}

PipelineTransformationsDrawerHeader.propTypes = {
  title: PropTypes.string.isRequired,
  documentationUrl: PropTypes.string,
};
